export default __webpack_public_path__ + "859a89ecb8d3312b06497478718c0f29.svg";